<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <Alert
          :type="alertType"
          :message="alertMessage"
          v-if="alertShow === true"
        />
        <div class="loading" v-if="asyncDone === false">Loading&#8230;</div>
      </div>
      <div class="col-12 mr-auto ml-auto">
        <!--      Wizard container        -->
        <div class="wizard-container">
          <div
            class="card card-wizard animated fadeIn"
            data-color="primary"
            id="wizardProfile"
          >
            <form action="" method="" id="demo">
              <div class="card-header text-center">
                <h3 class="card-title">
                  Migration Request
                </h3>
                <h5 class="description">
                  Please be as accurate as possible, and be sure to let us know
                  if there is anything at all we can help with!
                </h5>
                <div class="wizard-navigation">
                  <ul>
                    <li class="nav-item">
                      <a
                        class="nav-link active"
                        href="#introduction"
                        data-toggle="tab"
                        role="tab"
                        aria-controls="introduction"
                        aria-selected="true"
                      >
                        <i class="nc-icon nc-single-02"></i> Introduction
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#siteDetails"
                        data-toggle="tab"
                        role="tab"
                        aria-controls="account"
                        aria-selected="true"
                      >
                        <i class="nc-icon nc-world-2"></i> Site Details
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#domainDetails"
                        data-toggle="tab"
                        role="tab"
                        aria-controls="address"
                        aria-selected="true"
                      >
                        <i class="nc-icon nc-app"></i> Domain Details
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#additionalDetails"
                        data-toggle="tab"
                        role="tab"
                        aria-controls="address"
                        aria-selected="true"
                      >
                        <i class="nc-icon nc-atom"></i> Additional Details
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#email"
                        data-toggle="tab"
                        role="tab"
                        aria-controls="address"
                        aria-selected="true"
                      >
                        <i class="nc-icon nc-email-85"></i> Email
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link"
                        href="#overview"
                        data-toggle="tab"
                        role="tab"
                        aria-controls="address"
                        aria-selected="true"
                      >
                        <i class="nc-icon nc-spaceship"></i> Overview &amp;
                        Finalize
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body">
                <div class="tab-content">
                  <Introduction :planIndex="pIndex" />
                  <SiteDetails
                    :domainToMigration="domainToMigration"
                    v-on:onCancel="cancel($event)"
                  />
                  <DomainDetails />
                  <AdditionalDetails />
                  <EmailDetails />
                  <Overview />
                </div>
              </div>
              <div class="card-footer pb-4">
                <div class="pull-right">
                  <button
                    :disabled="
                      !hostVideoAccessResponseFlag ||
                        (this.shouldAddCollaborator &&
                          this.addedCollaborators.length === 0)
                    "
                    type="button"
                    class="btn btn-next btn-fill btn-rose btn-wd btn-primary"
                    name="next"
                    @click="next"
                  >
                    Next
                  </button>
                  <button
                    type="button"
                    class="btn btn-finish btn-fill btn-rose btn-wd btn-primary d-none"
                    name="finish"
                  >
                    Finish
                  </button>
                </div>
                <div class="pull-left">
                  <button
                    type="button"
                    :disabled="!hostVideoAccessResponseFlag"
                    class="btn btn-previous btn-fill btn-default btn-wd btn-primary"
                    name="previous"
                    id="previous"
                  >
                    Previous
                  </button>
                </div>
                <div class="clearfix"></div>
              </div>
            </form>
          </div>
        </div>
        <!-- wizard container -->
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../../../../main";

export default {
  name: "requestMigrationPage",
  components: {
    Alert: () =>
      import(
        /* webpackChunkName: "alert" */ "../../../../components/Alerts.vue"
      ),
    Introduction: () =>
      import(
        /* webpackChunkName: "migrationIntro" */ "../../../../components/User/Migration/RequestMigration/Introduction.vue"
      ),
    SiteDetails: () =>
      import(
        /* webpackChunkName: "migrationSiteDetails" */ "../../../../components/User/Migration/RequestMigration/SiteDetails.vue"
      ),
    DomainDetails: () =>
      import(
        /* webpackChunkName: "migrationDomainDetails" */ "../../../../components/User/Migration/RequestMigration/DomainDetails.vue"
      ),
    AdditionalDetails: () =>
      import(
        /* webpackChunkName: "migrationAdditionalDetails" */ "../../../../components/User/Migration/RequestMigration/AdditionalDetails.vue"
      ),
    EmailDetails: () =>
      import(
        /* webpackChunkName: "migrationEmailDetails" */ "../../../../components/User/Migration/RequestMigration/EmailDetails.vue"
      ),
    Overview: () =>
      import(
        /* webpackChunkName: "migrationOverview" */ "../../../../components/User/Migration/RequestMigration/OverviewFinalize.vue"
      ),
  },

  props: {
    pIndex: Number,
    domainToMigration: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    alertType() {
      return this.$store.getters["alert/type"];
    },
    alertMessage() {
      return this.$store.getters["alert/message"];
    },
    alertShow() {
      return this.$store.getters["alert/show"];
    },
    shouldAddCollaborator() {
      return this.$store.getters["migration/shouldAddCollaborator"];
    },
    addedCollaborators() {
      return this.$store.getters["migration/getAddedCollaborators"];
    },
    hostVideoAccessResponseFlag() {
      return this.$store.getters["migration/getHostVideoAccessResponseFlag"];
    },
  },
  methods: {
    cancel(data) {
					if (data.value) {
						const elem = document.getElementById("previous");
						elem.click();
          }

    },
    next() {
    eventBus.$emit("nextPage", {
        page: document
          .querySelector(".moving-tab")
          .textContent.toLowerCase()
          .trim(),
      });
    },
    preventUserToCloseTab(e) {
      e.preventDefault();
      e.returnValue = "";
    },
  },
  created() {
    const self = this;
    console.log("adding event");
    window.addEventListener("beforeunload", self.preventUserToCloseTab);
    /* eslint-disable */
    $(document).ready(function() {
      // Initialise the wizard
      demo.initWizard();

      setTimeout(function() {
        $(".card.card-wizard").addClass("active");
      }, 600);
    });
    /* eslint-enable */
    this.$store.commit("migration/mutateHostVideoAccessResponseFlag", true);
  },
  updated() {
    /* eslint-disable */
    $(document).ready(function() {
      // Initialise the wizard
      demo.initWizard();
      setTimeout(function() {
        $(".card.card-wizard").addClass("active");
      }, 600);
    });
    /* eslint-enable */
  },
  beforeDestroy() {
    const self = this;
    window.removeEventListener("beforeunload", self.preventUserToCloseTab);
    console.log("Reset migration data...");
    this.$store.commit("migration/reset");
  },
};
</script>

<style lang="scss">
.wizard-navigation {
  .nav-pills {
    .nav-item {
      a {
        cursor: context-menu;
        &:hover {
          cursor: context-menu;
        }
      }
    }
  }
  .moving-tab {
    cursor: context-menu;
  }
}
</style>
